import React from "react";
import Styles from "./Home.module.css";

import Carousel from "../components/home/Carousel";
import WhoWeAre from "../components/home/WhoWeAre";
import WhatDoWeOffer from "../components/home/WhatDoWeOffer";
import HighlyRatedGuids from "../components/home/HighlyRatedGuids";
import GoToTop from "../components/GotoTop";

function Home() {
	return (
		<div className={Styles.homeContainer}>
			<Carousel />
			<WhoWeAre />
			<WhatDoWeOffer />
			<HighlyRatedGuids />
			<GoToTop />
		</div>
	);
}

export default Home;
